// src/Login.js
import { useState, useContext } from 'react';
import { useNavigate }          from 'react-router-dom';
import axiosInstance            from './axiosInstance';
import { initiateSocket }       from './socket';
import { AuthContext }          from './context/AuthContext';

export default function Login() {
  /* ── form state ───────────────────────────────────────── */
  const [id,       setId]   = useState('');
  const [password, setPass] = useState('');
  const [msg,      setMsg]  = useState('');

  const navigate            = useNavigate();
  const { refreshUser }     = useContext(AuthContext);

  /* ── submit ───────────────────────────────────────────── */
  async function handleLogin(e) {
    e.preventDefault();
    setMsg('');

    try {
      const { status } = await axiosInstance.post('auth/login', {
        usernameOrEmail: id,
        password
      });

      if (status === 200) {
        initiateSocket();
        await refreshUser();
        // Check user preferences for custom landing page
        try {
          const { data: me } = await axiosInstance.get('auth/me');
          const landing = me?.preferences?.defaultLandingPage || '/main-homepage';
          navigate(landing);
        } catch {
          navigate('/main-homepage');
        }
      }
    } catch (err) {
      const code = err.response?.status || 0;
      setMsg(code === 401 ? 'Invalid credentials' : 'Login error');
    }
  }

  /* ── UI ──────────────────────────────────────────────── */
  return (
    <div className="form-container">
      <h1 className="portal-title">Solum Self Service Portal</h1>

      <form className="login-box" onSubmit={handleLogin} noValidate>
        <input
          type="text"
          placeholder="Username / Email"
          value={id}
          onChange={e => setId(e.target.value)}
          autoComplete="username"
          autoFocus
          required
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPass(e.target.value)}
          autoComplete="current-password"
          required
        />

        <button type="submit">Login</button>
      </form>

      {msg && <p className="error-msg">{msg}</p>}
    </div>
  );
}
